






























































import rest from "@/rest";
import { Component, Vue } from "vue-property-decorator";
import { EmailQueueEntryVm } from "@/interfaces/EmailQueueEntryVm";
import { EmailUsageStatisticVm } from "@/interfaces/EmailUsageStatisticVm";

@Component
export default class EmailQueue extends Vue {
  searchValue = "";
  showOnlyNotSendEmails = false;
  selectedView = "queue";
  queue: EmailQueueEntryVm[] = [];
  emailUsageStatistics: EmailUsageStatisticVm[] = [];

  // $refs!: {};

  headers = [
    { text: "Zugefügt",value: "enqueueDate",sortable: true },
    { text: "Versand", value: "sendDate",sortable: true },
    { text: "Meldung", align: "left", value: "loggingMessage", sortable: true },
    { text: "Wiederholungen", value: "retryCount",sortable: true },
    { text: "Priorität", value: "sendWithPriority",sortable: true },
  ];

  statisticsHeaders = [
    { text: "Monat", value: "date", sortable: true },
    { text: "Versendete E-Mails", value: "sendMails", sortable: true },
    { text: "Priorisierte E-Mails", value: "priorityMails", sortable: true },
    { text: "Abgelehnte E-Mails", value: "rejectedMails", sortable: true },
    { text: "Wiederholungen", value: "retries", sortable: true },
  ];

  mounted() {
    this.updateQueue();
  }

  async onSearchChanged() {
    await this.updateQueue();
  }

  async onShowOnlyNotSendEmails() {
    await this.updateQueue();
  }

  async onViewChanged(view: string | null) {
    if (view === "statistics")
      await this.updateEmailUsageStatistics();
    else if (view === "queue")
      await this.updateQueue();
  }

  async updateQueue() {
    this.queue = await rest.url("admin/getEmailQueueEntries").query({ search: this.searchValue ?? "", showOnlyNotSendEmails : this.showOnlyNotSendEmails }).get();
  }

  async updateEmailUsageStatistics() {
    this.emailUsageStatistics = await rest.url("admin/getEmailUsageStatistics").get();
  }
}
